"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageKey = void 0;
var StorageKey;
(function (StorageKey) {
    StorageKey["OAUTH_REDIRECT_URL"] = "oauthRedirectUrl";
    StorageKey["PKCE_SECRET"] = "pkceSecret";
    StorageKey["APPLICATION_ID"] = "applicationId";
    StorageKey["BASE_URL"] = "baseUrl";
})(StorageKey = exports.StorageKey || (exports.StorageKey = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25zdGFudHMvc3RvcmFnZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFZLFVBS1g7QUFMRCxXQUFZLFVBQVU7SUFDcEIscURBQXVDLENBQUE7SUFDdkMsd0NBQTBCLENBQUE7SUFDMUIsOENBQWdDLENBQUE7SUFDaEMsa0NBQW9CLENBQUE7QUFDdEIsQ0FBQyxFQUxXLFVBQVUsR0FBVixrQkFBVSxLQUFWLGtCQUFVLFFBS3JCIn0=